import React from "react";
import { t } from "ttag";

import { useAppDispatch, useAppSelector } from "../../reducers";
import { Actions } from "../actions";
import { IAddress } from "../models.interfaces";
import { FormView } from "./abstract/FormView";

interface IProps {
    address: Partial<IAddress>;
}

export const CustomerDetailsAddress = (props: IProps) => {
    const countries = useAppSelector((state) => state.csr.countries);
    const dispatch = useAppDispatch();
    const actions = new Actions(dispatch);

    return (
        <FormView
            url={props.address.url}
            baseURL={"/api/csr/user-addresses/"}
            actions={actions}
            fields={[
                {
                    name: "user",
                    type: "hidden",
                },
                {
                    label: t`Title`,
                    name: "title",
                    type: "select",
                    options: [
                        ["", ""],
                        ["Mr", t`Mr`],
                        ["Miss", t`Miss`],
                        ["Mrs", t`Mrs`],
                        ["Ms", t`Ms`],
                        ["Dr", t`Dr`],
                    ],
                },
                {
                    label: t`First Name`,
                    name: "first_name",
                    type: "text",
                },
                {
                    label: t`Last Name`,
                    name: "last_name",
                    type: "text",
                },
                {
                    label: t`Line 1`,
                    name: "line1",
                    isRequired: true,
                    type: "text",
                },
                {
                    label: t`Line 2`,
                    name: "line2",
                    type: "text",
                },
                {
                    label: t`City`,
                    name: "line4",
                    type: "text",
                },
                {
                    label: t`State/Province`,
                    name: "state",
                    type: "text",
                },
                {
                    label: t`ZIP Code`,
                    name: "postcode",
                    type: "text",
                },
                {
                    label: t`Country`,
                    name: "country",
                    type: "select",
                    options: countries.map((c): [string, string] => {
                        return [c.url, c.printable_name];
                    }),
                },
                {
                    label: t`Is Default Shipping Address`,
                    name: "is_default_for_shipping",
                    type: "boolean",
                },
                {
                    label: t`Is Default Billing Address`,
                    name: "is_default_for_billing",
                    type: "boolean",
                },
            ]}
            initialValues={props.address}
        />
    );
};
